import { cloneElement, Fragment, isValidElement, ReactElement } from "react";

// Interfaces
import { ISideTreeIcon } from "../../interfaces";

// MUI
import { Skeleton, Stack } from "@mui/material";
import clsx from "clsx";

export default function SideTreeIcon(props: Readonly<ISideTreeIcon>) {
	const { iconNode = null, component = null, sx = null, disabled = false, loading = false, selected = false } = props;

	if (loading) {
		return (
			<Skeleton
				className={clsx({
					"!bg-white": selected,
				})}
				variant="circular"
				height={21}
				width={21}
			/>
		);
	}

	if (component && Boolean(isValidElement(component))) {
		return <Fragment>{cloneElement(component as ReactElement, { ...props })}</Fragment>;
	}

	if (!iconNode) {
		return null;
	}

	return (
		<Stack
			className={clsx({
				"[&>svg]:!text-white [&>svg]:!fill-white": selected && !disabled,
				"[&>svg]:!text-disabled": disabled,
			})}
			direction={"row"}
			alignContent={"end"}
			alignItems={"center"}
			justifyContent={"end"}
			sx={sx}
		>
			{iconNode}
		</Stack>
	);
}
